module.exports = __webpack_public_path__ + "assets/img/interesting-games.2d8725bc.png";